var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Box, Typography } from '@mui/material';
import { TipoProcessoEnum } from '../../../../model/enums/TipoProcessoEnum';
import { ViewSection } from '../components/ViewSection';
// Imports from original components
import { DadosImovelRegFundUrbana } from "../../Cadastro/PrimeiraAba/RegularizaçaoFundiariaUrbana/DadosImovelRegFundUrbana";
import { DadosImovelRatTitUrbano } from "../../Cadastro/PrimeiraAba/TituloUrbano/TituloUrbano";
import { DadosImovelAssentado } from "../../Cadastro/PrimeiraAba/DeclaracaoAssentado/DadosImovelAssentado";
import { DadosImovelRegFundRuralAssentamento } from "../../Cadastro/SegundaAba/RegFundRuralAssentamento/DadosImovelRegFundRuralAssentamento";
import { DadosImovelBuscaPesquisa } from "../../Cadastro/SegundaAba/BuscaPesquisa/BuscaPesquisa";
import { DadosImovelRegFundRural } from "../../Cadastro/SegundaAba/RegularizacaoFundiariaRural/DadosImovelRegFundRural";
import { DadosImovelCertIntTeor } from "../../Cadastro/SegundaAba/CertInteiroTeor/DadosImovelCertIntTeor";
import { DadosImoveAverbTitJudicial } from "../../Cadastro/SegundaAba/AverbacaoTituloJudicial/DadosImoveAverbTitJudicial";
import { DadosImovelRetTituloDef } from "../../Cadastro/SegundaAba/TituloDefinitivo/TituloDefitivo";
import { DadosImovelCopiaDig } from "../../Cadastro/SegundaAba/DadosImovelCargCop";
import { DadosImovelLocalizacaoRural } from "../../Cadastro/SegundaAba/DadosImovelLocalizacaoRural";
import { DadosImovelDecRecLimites } from "../../Cadastro/SegundaAba/ReconhecimentoLimites/DadosImovelDecRecLimites";
import { DadosImovelUsucapiaoRural } from "../../Cadastro/SegundaAba/DadosImovelUsucapiaoRural";
import { SolicitarEstudoCadastral } from "../../Cadastro/SegundaAba/solicitarEstudoCadastral/SolicitarEstudoCadastral";
import { CadastroImovelCertidaoDomicilioFiscal } from "../../Cadastro/SegundaAba/EmpreendimentoRural/CadastroCertidaoDomicilioFiscal";
var mapTypeToComponent = (_a = {},
    _a[TipoProcessoEnum.REGULARIZACAO_FUNDIARIA_URBANA] = DadosImovelRegFundUrbana,
    _a[TipoProcessoEnum.RATIFICACAO_TITULO_DEF_URBANO] = DadosImovelRatTitUrbano,
    _a[TipoProcessoEnum.BUSCA_PESQUISA] = DadosImovelBuscaPesquisa,
    _a[TipoProcessoEnum.REGULARIZACAO_RURAL] = DadosImovelRegFundRural,
    _a[TipoProcessoEnum.CERTIDAO_INTEIRO_TEOR_RURAL_URBANO] = DadosImovelCertIntTeor,
    _a[TipoProcessoEnum.AVERBACAO_TITULO_JUDICIAL] = DadosImoveAverbTitJudicial,
    _a[TipoProcessoEnum.RETIFICACAO_TITULO_DEFINITIVO] = DadosImovelRetTituloDef,
    _a[TipoProcessoEnum.CERTIDAO_LOCALIZACAO_RURAL] = DadosImovelLocalizacaoRural,
    _a[TipoProcessoEnum.DECLARACAO_RECONHECIMENTO_LIMITES] = DadosImovelDecRecLimites,
    _a[TipoProcessoEnum.CERTIDAO_FINS_USUCAPIAO_RURAL] = DadosImovelUsucapiaoRural,
    _a[TipoProcessoEnum.DECLARACAO_ASSENTADO] = DadosImovelAssentado,
    _a[TipoProcessoEnum.REGULARIZACAO_FUND_RURAL_ASSENTAMENTO] = DadosImovelRegFundRuralAssentamento,
    _a[TipoProcessoEnum.ESTD_CAD] = SolicitarEstudoCadastral,
    _a[TipoProcessoEnum.CERTIDAO_DOMICILIO_FISCAL_EMP_RURAL] = CadastroImovelCertidaoDomicilioFiscal,
    _a[TipoProcessoEnum.CERTIDAO_ADMINISTRATIVA] = DadosImovelCopiaDig,
    _a[TipoProcessoEnum.SOLICITAR_CARGA_COPIA_DIGITALIZADA] = DadosImovelCopiaDig,
    _a[TipoProcessoEnum.MAPA_MEMORIAL] = DadosImovelCopiaDig,
    _a);
export var AbaBusca = function (_a) {
    var _b;
    var requerimento = _a.requerimento;
    var tipoRequerimento = (_b = requerimento.servico) === null || _b === void 0 ? void 0 : _b.referenciaServico;
    // Safety check just in case
    var Component = tipoRequerimento ? mapTypeToComponent[tipoRequerimento] : undefined;
    var getTitle = function () {
        if (tipoRequerimento === TipoProcessoEnum.BUSCA_PESQUISA) {
            return 'Dados da Busca';
        }
        var processTypes = [
            TipoProcessoEnum.CERTIDAO_ADMINISTRATIVA,
            TipoProcessoEnum.SOLICITAR_CARGA_COPIA_DIGITALIZADA,
            TipoProcessoEnum.MAPA_MEMORIAL
        ];
        if (tipoRequerimento && processTypes.includes(tipoRequerimento)) {
            return 'Dados do Processo';
        }
        return 'Dados do Imóvel';
    };
    if (!Component) {
        return (_jsx(Box, __assign({ sx: { p: 4, textAlign: 'center' } }, { children: _jsxs(Typography, __assign({ variant: "body1", color: "textSecondary" }, { children: ["Nenhum componente de dados dispon\u00EDvel para este tipo de requerimento: ", tipoRequerimento] })) })));
    }
    return (_jsx(Box, __assign({ sx: { mt: 2, pointerEvents: 'none', opacity: 0.8, '& .MuiInputBase-root': { backgroundColor: '#f0f0f0' } } }, { children: _jsx(ViewSection, __assign({ title: getTitle() }, { children: _jsx("fieldset", __assign({ disabled: true, style: { border: 'none', margin: 0, padding: 0 } }, { children: _jsx(Component, { requerimento: requerimento, onChange: function () { }, onValidate: function () { }, isView: true }) })) })) })));
};
